import { useState } from 'react';
import styles from './Faq.module.scss';

export const Faq = ({ content }) => {
  const [openIndex, setOpenIndex] = useState(0);
  if (!content) return;

  const { title, faq } = content;


  const handleToggle = (idx) => {
    setOpenIndex(idx === openIndex ? null : idx); // Клик по открытому — закрывает
  };

  return (
    <div className={styles.wrapper}>
      {title && (
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className={styles.faq}>
        {faq &&
          faq.map((item, index) => {
            const { question, answer } = item;
            const isOpen = openIndex === index;
            return (
              <div
                className={`${styles.item} ${isOpen ? styles.open : ''}`}
                key={index}
              >
                <div
                  className={styles.question}
                  onClick={() => handleToggle(index)}
                  tabIndex={0}
                  role="button"
                  aria-expanded={isOpen}
                >
                  <div>{question}</div>
                  <div className={styles.arrow}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      style={{
                        transform: isOpen
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.2s',
                      }}
                    >
                      <path
                        d="M4 6L8 10L12 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className={styles.answerWrapper}>
                    <div className={styles.answer}>
                      {
                        answer.map((ans, ansIdx) => (
                          <div
                            key={ansIdx}
                            
                            dangerouslySetInnerHTML={{ __html: ans }}
                          />
                        ))
                      }
                    </div>
                </div>
                  
              </div>
            );
          })}
      </div>
    </div>
  );
};
